<script>
import { useColorMode } from "@vueuse/core";
import { computed } from "vue";

export function useUiTheme() {
  // emitAuto:true で store.value に 'auto' も含まれるようになる
  const mode = useColorMode({
    attribute: "class",
    valueDark: "dark",
    valueLight: "light",
    emitAuto: true,
  });
  const system = mode.system; // 'dark' | 'light'
  const store = mode.store; // 'dark' | 'light' | 'auto'

  // 実際に適用中のモード: auto->system それ以外は store
  const themeMode = computed(() => mode.store.value);
  const currentTheme = computed(() => mode.store.value === "auto" ? system.value : mode.store.value);

  return {
    themeMode,
    currentTheme,
    setLight: () => (mode.value = "light"),
    setDark: () => (mode.value = "dark"),
    setAuto: () => (mode.value = "auto"),
  };
}
</script>
